import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Output,
  input
} from '@angular/core';

/**
 * Conversation-starter chip. `block w-full` on the host so every chip is the
 * same width inside `<m-tab-view>`'s templated slot regardless of label length.
 */
@Component({
  selector: 'portal-starter-chip',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './starter-chip.component.html',
  host: { class: 'block w-full' }
})
export class PortalStarterChipComponent {
  readonly label = input.required<string>();
  readonly disabled = input(false);
  @Output() readonly clicked = new EventEmitter<void>();
}
